module.exports = __webpack_public_path__ + "static/media/cultist.998af3b1.svg";